import IconStop from "components/icons/stop.icon";
import { useState } from "react";
import intl from "react-intl-universal";
import ModalConfirmCancel from "./modal-confirm-cancel";
import { getUserId } from "utils/user";
import { useGlobalContext } from "hooks/useGlobalContext";
import { useOrderVolumeContext } from "features/order-volume/context";
import ButtonIcon from "components/button-icon";

interface IProps {
  refresh: (newFilter?: any) => Promise<void>;
  volumeOrdersIds: number[];
}

const OrderVolumeCancel = ({
  refresh,
  volumeOrdersIds,
}: IProps) => {
  const { setLoading } = useOrderVolumeContext();
  const { startOperation } = useGlobalContext();
  const isDisabled = volumeOrdersIds.length == 0;
  const [showModalCancel, setShowModalCancel] = useState(false);
  const userId = getUserId();

  const handleCancelVolumes = async () => {
    try {
      setLoading(true);
      const requests = volumeOrdersIds.map(x => ({
        API: `volume-orders/${x}:cancel`,
        method: 'post',
        body: { userId }
      }));
      const text = intl.get('orders.operationText02');
      startOperation(requests, text, refresh);
    } finally {
      setLoading(false);
      setShowModalCancel(false);
    }
  };

  return (
    <>
      <ButtonIcon
        buttonIcon={<IconStop />}
        buttonText={intl.get("volumeOrders.cancelVolumes")}
        className="btnCancel"
        buttonType="default"
        disabled={isDisabled}
        onClick={() => setShowModalCancel(true)}
        style={{ width: '166px' }}
      />
      {showModalCancel && (
        <ModalConfirmCancel
          visible={showModalCancel}
          onConfirm={handleCancelVolumes}
          onCancel={() => setShowModalCancel(false)}
        />
      )}
    </>
  );
};

export default OrderVolumeCancel;
